import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
// import ShopContextProvider from './context/shop-context';
import { store } from './store/store'
import { Provider } from 'react-redux'
import { AppContextProvider } from './context/appContext'

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <AppContextProvider>
    <Provider store={store}>
      <App />
    </Provider>
  </AppContextProvider >
);
reportWebVitals();
